/**
 * Created by mongoose on 14/11/17.
 */
import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap";
// @ts-ignore
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { defineMessages, useIntl } from "react-intl";

export const messages = defineMessages({
  search: {
    id: "widget.duallistbox.search",
    description: "placeholder",
    defaultMessage: "Search...",
  },
});

export interface ValueOption<T> {
  label: string;
  value: T;
}

interface Field<T> {
  fieldName: string;
  options: ValueOption<T>[];
  disabled: boolean;
  leftListHeader: string;
  rightListHeader: string;
  filterPlaceholder: string;
}

function DualListBoxGroup<T>({
  value,
  onChange,
  field,
}: {
  value: T[];
  onChange: ({ value, field }: { value: T[]; field: Field<T>["fieldName"] }) => void;
  field: Field<T>;
}) {
  const {
    fieldName,
    options,
    disabled,
    leftListHeader,
    rightListHeader,
    filterPlaceholder,
  } = field;
  const intl = useIntl();
  const filterBarMessage = filterPlaceholder || intl.formatMessage(messages.search);
  const handleChange = useCallback(
    (values: T[]) => {
      onChange({ value: values, field: fieldName });
    },
    [onChange, fieldName]
  );

  return (
    <div>
      <FormGroup>
        <DualListBox
          options={options}
          selected={value}
          onChange={handleChange}
          disabled={disabled}
          filterPlaceholder={filterBarMessage}
          lang={{ availableHeader: leftListHeader, selectedHeader: rightListHeader }}
          showHeaderLabels
          canFilter
        />
      </FormGroup>
    </div>
  );
}

DualListBoxGroup.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DualListBoxGroup;
